export default "__VITE_ASSET__D4osalBh__"